import loadingIcon from "../icons/loading-icon.svg";
export const Spinner = ({ text = "Loading..." }) => {
    return (
        <div className="flex flex-column gap-y-8 justify-center items-center">
            <img src={loadingIcon} alt={text} />
        </div>
    );
};
